// @flow
import type {
  Category,
  Region,
  Hub,
  Territory,
  Representative,
  Grower,
  SalesOffice,
  Farm,
  Field,
  ManagementZones,
  Harvest,
  Applied,
  Profit,
  Prediction,
  CropHealth,
} from 'fc-flow-types/models'

export const MODEL = 'Assets'

// Api End Point
export const URL = 'asset/'
export const FIELD_URL = 'asset/field/'
export const SUBFIELD_URL = 'asset/subfield/'

// Categories
export const REGION: Region = 'Region'
export const HUB: Hub = 'Hub'
export const TERRITORY: Territory = 'Territory'
export const REPRESENTATIVE: Representative = 'Representative'
export const GROWER: Grower = 'Grower'
export const SALES_OFFICE: SalesOffice = 'Sales Office'
export const FARM: Farm = 'Farm'
export const FIELD: Field = 'Field'
export const MANAGEMENT_ZONES: ManagementZones = 'Management Zones'
export const HARVEST: Harvest = 'Harvest'
export const APPLIED: Applied = 'Applied'
export const PROFIT: Profit = 'Profit'
export const PREDICTION: Prediction = 'Prediction'
export const CROP_HEALTH: CropHealth = 'Crop Health'

export const assetCategories: Array<Category> = [
  REGION,
  HUB,
  TERRITORY,
  REPRESENTATIVE,
  GROWER,
  SALES_OFFICE,
  FARM,
  FIELD,
  MANAGEMENT_ZONES,
  CROP_HEALTH,
  HARVEST,
  APPLIED,
  PROFIT,
  PREDICTION,
]

export const rootCategories: Array<Category> = [
  REGION, HUB, TERRITORY, REPRESENTATIVE, GROWER, SALES_OFFICE, FARM,
]

export const fieldRelatedCategories: Array<Category> = [
  FARM, FIELD, MANAGEMENT_ZONES, CROP_HEALTH, HARVEST, APPLIED, PROFIT, PREDICTION,
]

export const subfieldCategories: Array<Category> = [
  MANAGEMENT_ZONES, CROP_HEALTH, HARVEST, APPLIED, PROFIT, PREDICTION,
]

// Model Attributes
export const PROP_ID = 'id'
export const PROP_ASSET_ID = PROP_ID
export const PROP_PARENT = 'parent'
export const PROP_LABEL = 'label'
export const PROP_CATEGORY = 'category'
export const PROP_SEASON = 'season'
export const PROP_SHAPE = 'shape'
export const PROP_LAYERS = 'layers'

const FARM_QUERY = 'category == \'"Farm"\''
const GROWER_QUERY = 'category == \'"Grower"\''
const TERRITORY_QUERY = 'category == \'"Territory"\' '
const SALESOFFICE_QUERY = 'category == \'"Sales Office"\''
const REPRESENTATIVE_QUERY = 'category == \'"Representative"\''
const HUB_QUERY = 'category == \'"Hub"\''
const REGION_QUERY = 'category == \'"Region"\''
const FIELD_QUERY = 'category == \'"Field"\''

/* This defines the realm schema used by the mobile team for
    offline data storage. If you have questions please ask anyone
    on the mobile team.
  Valid types are:
  string: a string
  int: any non-floating point number
  float: any floating point number
  double: a double precision floating point number
  bool: a javascript boolean
  data: if you are unfamiliar with realm don't use this
  date: maps to javascript Date
*/
export const SCHEMA = [{
  name: MODEL,
  primaryKey: PROP_ID,
  properties: {
    id: {type: 'int'},
    asset: {type: 'int', optional: true},
    parent: {type: 'int', optional: true},
    label: {type: 'string'},
    category: {type: 'string', optional: true},
    season: {type: 'int', optional: true},
    shape: {type: 'string', optional: true},
    layers: {type: 'string', optional: true},
  },
}]

export function translateQueryParams (params: Object): string {
  let query = ''
  for (let attr in params) {
    if (attr === 'toFarmsOnly' && params[attr] === 'True') {
      query += query === '' ? '' : ' && '
      query += FARM_QUERY + ' || ' + GROWER_QUERY + ' || ' + TERRITORY_QUERY + ' || ' + SALESOFFICE_QUERY + ' || ' +
      REPRESENTATIVE_QUERY + ' || ' + HUB_QUERY + ' || ' + REGION_QUERY
    } else if (attr === 'shape' && params[attr]) {
      query += query === '' ? '' : ' && '
      query += 'shape != null || shape != \'null\''
    } else if (attr === 'category') {
      switch (params[attr]) {
        case FIELD:
          query += query === '' ? '' : ' && '
          query += FIELD_QUERY
          break
      }
    }
  }
  return query
}
